// Testers whose enquiries are off until they turn them back on in their account
// settings. Turning the setting on or off writes publicData.enquiriesPaused on
// the listing, which then wins over this list.
export const ENQUIRIES_PAUSED_LISTING_IDS = [
  '65df5530-0d7f-45b9-a039-0a27b2ba49e0', // Go_getter9289
  '6a6d29cd-1ab6-4e0e-b17d-3e023ebe52ce', // TinyDuster
  '6a44279e-b509-49b0-a88e-ab91467f3363', // Bmxbmlx1
  '6a347531-91cc-4480-a88b-f4969b2d4c87', // EmilyB00
  '6a27a869-967e-4bb6-8971-f7802cf08ba3', // GoodgirlAnnaMarie
  '6a247150-5f94-42bd-b3e0-47b4c4295ca0', // LoyalLady
  '68e94d93-2b07-41c7-a564-8755e4f98f6b', // mari.tells.all
  '649ba727-a14e-40b2-bcaf-087b3968f389', // LiraHyst
  '63fd1ba5-5d67-497e-a45b-78980fc0a9f2', // pikabett
  '669d75e1-2c70-48e4-98c1-eb55ad223232', // KellyRiazz
];

// True when the tester hasn't set enquiries on or off themselves and is on the
// list above, so the settings page can say why enquiries are off.
export const isEnquiriesPausedByUs = listing =>
  typeof listing?.attributes?.publicData?.enquiriesPaused !== 'boolean' &&
  ENQUIRIES_PAUSED_LISTING_IDS.includes(listing?.id?.uuid);

export const isEnquiriesPaused = listing => {
  const paused = listing?.attributes?.publicData?.enquiriesPaused;
  return typeof paused === 'boolean' ? paused : isEnquiriesPausedByUs(listing);
};
